// src/components/Footer.js
import React from 'react';

const footerStyle = {
  textAlign: 'center',
  padding: '2.5rem 2rem 2rem',
  background: '#f5f5f5',
  color: '#5f6368',
  borderTop: '1px solid #e5e5e5',
  boxShadow: '0 -1px 2px rgba(0, 0, 0, 0.05)',
  fontSize: '0.9rem',
  marginTop: 'auto',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif'
};

const copyrightStyle = {
  marginBottom: '0.75rem',
  fontWeight: 400,
  fontSize: '0.85rem',
  letterSpacing: '0.3px',
  color: '#9aa0a6'
};

const containerStyle = {
  display: 'flex',
  justifyContent: 'center',
  gap: '2rem',
  flexWrap: 'wrap'
};

const linkStyle = {
  color: '#0066cc',
  textDecoration: 'none',
  fontWeight: 600,
  transition: 'all 0.2s ease',
  fontSize: '0.9rem'
};

const linkHoverStyle = {
  ...linkStyle,
  color: '#0052a3',
  textDecoration: 'underline'
};

const Link = ({ href, children }) => {
  const [isHover, setIsHover] = React.useState(false);
  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noopener noreferrer"
      style={isHover ? linkHoverStyle : linkStyle}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {children}
    </a>
  );
};

const Footer = () => (
  <footer style={footerStyle}>
    <p style={copyrightStyle}>
      &copy; {new Date().getFullYear()} Talyfax. All rights reserved.
    </p>
    <div style={containerStyle}>
      <Link href="https://twitter.com">Twitter</Link>
      <Link href="https://www.linkedin.com/company/talyfax">LinkedIn</Link>
      <Link href="https://github.com">GitHub</Link>
    </div>
  </footer>
);

export default Footer;